import {
  MarketplaceItem as Model,
  ResourceStore,
} from '@/internal';

const service = new Model.service();

const store = new ResourceStore({
  model: Model,
  actions: {
    import: ({commit}, payload) => {
      return service.import(payload.id, payload).then((response) => {
        return ResourceStore.processData(Model.key, commit, response.data);
      });
    },
    rate: ({commit}, payload) => {
      return service.rate(payload.id, payload).then((response) => {
        return ResourceStore.processData(Model.key, commit, response.data);
      });
    },
    pullDown: ({commit}, payload) => {
      return service.destroy(payload.id, payload).then((response) => {
        return ResourceStore.processData(Model.key, commit, response.data);
      });
    },
    restore: ({commit}, payload) => {
      return service.restore(payload.id, payload).then((response) => {
        return ResourceStore.processData(Model.key, commit, response.data);
      });
    },
  },
});

export default store.toObject();
